import React from "react";

const items = [
  {
    icon: "🤖",
    title: "Meet SyCoDoca",
    text: "An AI-powered mental health ally built on Large Language Models to provide real-time psychiatric assessments and structured clinical reports.",
  },
  {
    icon: "🔬",
    title: "Smart AI Diagnostics",
    text: "Upload dental or medical X-rays for instant AI-driven analysis and diagnostic reports verified by licensed professionals.",
  },
  {
    icon: "🛡️",
    title: "Seamless Claim Processing",
    text: "Submit healthcare claims digitally and track their status in real-time with zero paperwork and secure, HIPAA-compliant documentation.",
  },
];

const InfoStrip = () => (
  <>
    <style>{`
      @keyframes slideInUp {
        from {
          opacity: 0;
          transform: translateY(30px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }

      @keyframes scaleIn {
        from {
          opacity: 0;
          transform: scale(0.8);
        }
        to {
          opacity: 1;
          transform: scale(1);
        }
      }

      @keyframes float {
        0%, 100% { transform: translateY(0px); }
        50% { transform: translateY(-10px); }
      }

      .info-item {
        animation: slideInUp 0.6s ease-out;
        transition: all 0.3s ease;
      }

      .info-item:nth-child(1) { animation-delay: 0.1s; }
      .info-item:nth-child(2) { animation-delay: 0.2s; }
      .info-item:nth-child(3) { animation-delay: 0.3s; }

      .info-item:hover {
        background: rgba(255, 255, 255, 0.08);
        transform: translateY(-8px);
        border-radius: 12px;
      }

      .info-icon {
        animation: float 3s ease-in-out infinite;
      }

      .info-item:hover .info-icon {
        animation: scaleIn 0.4s ease-out;
      }
    `}</style>
    <div className="bg-gradient-to-r from-[#1A7A7A] to-[#0D9DAD]">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-white/25">
        {items.map((item, idx) => (
          <div key={item.title} className="info-item px-8 py-7" style={{ animationDelay: `${idx * 0.1}s` }}>
            <div className="info-icon text-3xl mb-3 opacity-90">{item.icon}</div>
            <h4 className="text-white text-base font-semibold mb-1.5 transition-all duration-300">{item.title}</h4>
            <p className="text-white/70 text-sm leading-relaxed transition-all duration-300">{item.text}</p>
          </div>
        ))}
      </div>
    </div>
  </>
);

export default InfoStrip;
